// @ts-nocheck
import { TELCO } from "constants/common";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { urlAssetsCustom } from "utils/common";
const PopupGiftTopup = (props) => {
  const { onChangeInfo } = props;
  const navigate = useNavigate();
  const [data, setData] = useState(props?.dataModalTopup);
  const onExchangeCode = () => {
    props.exchangeCode({ ...data });
    document.body.classList.remove("modal-open");
  };
  const inputCodeAgain = () => {};
  console.log("props?.dataModalTopup", props?.dataModalTopup);
  return (
    <>
      <div className="popup-overlay modal-submit">
        <div className="popup-warp">
          <div className="popup-inner">
            <div className="content-popup">
              <h5>
                <img height={30} src="assets/img/logoFOOD.png" /> <br />
                XÁC NHẬN THÔNG TIN
                <br />
                DỰ THƯỞNG
              </h5>
              <p>
                Quý khách vui lòng kiểm tra lại thông tin
                <b> Số điện thoại</b> và <b>Mã dự thưởng</b> trước khi nhấn xác
                nhận (*)
              </p>

              <h3 className="name-gift">{data?.extraInfo?.name}</h3>
              <div className="form-group">
                <label className="title-form" htmlFor="phone">
                  Số điện thoại
                </label>
                <div className="form-field">
                  <input
                    type="tel"
                    className="form-control "
                    id="code"
                    maxLength={10}
                    name="code"
                    value={data?.phone}
                    min="0"
                    max="10"
                    inputMode="numeric"
                    readOnly
                  />
                </div>
              </div>
              <div className="form-group">
                <label className="title-form" htmlFor="phone">
                  Mã dự thưởng
                </label>
                <div className="form-field">
                  <input
                    type="tel"
                    className="form-control "
                    id="code"
                    maxLength={10}
                    name="code"
                    value={data?.code}
                    min="0"
                    max="10"
                    inputMode="numeric"
                    readOnly
                  />
                </div>
              </div>
              <b className="text-red">
                (*) BTC không chịu trách nhiệm nếu khách hàng cung cấp thông tin
                không chính xác
              </b>
            </div>
            <div className="btn-wrapper btn-center">
              <button
                type="button"
                className="btn btn-primary btn-border btn-block "
                onClick={onChangeInfo}
              >
                THAY ĐỔI THÔNG TIN
              </button>
              <button
                type="button"
                className="btn btn-primary  btn-block"
                onClick={onExchangeCode}
              >
                XÁC NHẬN
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupGiftTopup;
